import { render } from "./InviteActionModal.vue?vue&type=template&id=5475a5b7&scoped=true"
import script from "./InviteActionModal.vue?vue&type=script&lang=js"
export * from "./InviteActionModal.vue?vue&type=script&lang=js"

import "./InviteActionModal.vue?vue&type=style&index=0&id=5475a5b7&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5475a5b7"]])

export default __exports__